import React from 'react'
import { connect } from 'react-redux'
import { GiveThisGiftModal } from 'cart/containers/give-this-gift'
import {
  createReservation,
  fetchRegItem,
  updateRegItem,
} from 'registry/actions'
import { openRegistryViewPurchaseInformationModal } from 'registry/modals/actions'
import withBlinkyTitleBar from 'components/with-blinky-title-bar'

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: (reservation) =>
    dispatch(createReservation(reservation)).then((reservation) => {
      return dispatch(fetchRegItem(reservation.regItemId)).then(
        () => reservation
      ) // Resolve with reservation
    }),
  openPurchaseInfoModal: (regItem, reservation) =>
    dispatch(
      openRegistryViewPurchaseInformationModal({ regItem, reservation })
    ),
})

export default connect(
  null,
  mapDispatchToProps
)(withBlinkyTitleBar(GiveThisGiftModal))
